<template>
<div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center_buttons">
        <button class="btn btn-secondary" v-if="this.atual!=this.primeira" @click='$emit("anterior")'>Página anterior</button>
        <button class="btn btn-primary"  v-if="this.atual!=this.ultima" @click='$emit("proxima")'>Próxima página</button>
    </div>
</div>
</template>

<script>
    export default {
        props:['primeira','atual','ultima']
    }
</script>

<style scoped>
    .center_buttons{text-align:center;}
</style>
